import React, { useState } from 'react';
import { TextField, Button, Box, CircularProgress, Select, MenuItem, FormControl, InputLabel, FormHelperText, Input, Chip, Paper,Typography, FormControlLabel, Checkbox } from '@mui/material';
import axios from 'axios';

const CreateOtherPost = () => {
  const [positionName, setPositionName] = useState('');
  const [city, setCity] = useState([]);
  const [jobLink, setJobLink] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [linkedinImageURL, setlinkedinImageURL] = useState('');
  const [positionCategory, setPositionCategory] = useState('');
  const [jobType, setJobType] = useState('');
  const [jobStatus, setJobStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [linkedinChecked, setLinkedinChecked] = useState(true);
  const [error, setError] = useState('');

  // Türkiye'deki şehirlerin listesi
  const cities = [
    "Genel", "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
    "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis",
    "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce",
    "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane",
    "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman",
    "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya",
    "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye",
    "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat",
    "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Yurt Dışı"
  ];

  // Pozisyon kategorilerinin listesi
  const positionCategories = [
    "Araştırma Geliştirme (AR-GE)",
    "Geri Ödeme/Pazara Erişim",
    "Klinik Destek/Aplikasyon",
    "Kalite/Belgelendirme/Mevzuat",
    "Lojistik ve Tedarik Zinciri",
    "Pazarlama/Ürün Yönetimi",
    "Satış",
    "Teknik Servis",
    "Teknoloji Yönetimi",
    "Test/Kalibrasyon/Muayene",
    "Üretim",
    "Akademik",
    "Diğer"
  ];
  const handleCityChange = (event) => {
    setCity(event.target.value);
  };
  const handleChange = (event) => {
    setLinkedinChecked(event.target.checked);  
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Inputları kontrol et
    if (!positionName || !city || !jobLink || !companyName || !positionCategory || !jobType) {
      setError('Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // API'ye POST isteği gönder
      const response = await axios.post('https://kariyer.biyomed.net/api/admin/createOtherPost', {
        position_name: positionName,
        city: city.join(', '),
        job_link: jobLink,
        company_name: companyName,
        position_category: positionCategory,
        job_type: jobType,
        job_status: jobStatus,
        linkedinChecked:linkedinChecked,
        linkedinImageURL:linkedinImageURL,
      }, { withCredentials: true });

      // Başarılı yanıt durumunda
      console.log('Post created:', response.data);
      alert("Basariyla olusturuldu")
      window.location.href = "/admin/other-posts"
      // Success message or redirect
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Bilinmeyen bir hata oluştu. Lütfen tekrar denemeden önce çıkış yapıp tekrar admin girişi yapınız.";
      alert(`Post oluşturma başarısız: ${errorMessage}`);
      console.error('İş ilanı oluşturulurken bir hata oluştu:', err);
      setError('İş ilanı oluşturulurken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: '0 auto', padding: 2 }}>
      <h2>Yeni İş İlanı Oluştur</h2>
      <Box
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 1300,
          maxWidth: 400
        }}
      >
        <Paper
          elevation={4}
          sx={{
            padding: 2,
            borderLeft: '5px solid #0077b5',
            backgroundColor: '#f0f9ff',
            borderRadius: 2
          }}
        >
          <Typography variant="subtitle2" color="error" gutterBottom>
            Hatırlatma !!!
          </Typography>
          <Typography variant="body2" color="text.primary">
            İlan oluşturma LinkedIn ile entegreli çalışmaktadır. Oluşturulan ilan,
            Biyomedikal Mühendisleri Derneği LinkedIn sayfasında otomatik olarak paylaşılacaktır.
            Eğer yanlış bir duyuru girip silerseniz, LinkedIn tarafında da gerekli düzeltmeyi yapınız.<br/>
            <a style={{color:"green"}} href='https://www.linkedin.com/company/68533944'>LinkedIn sayfası için tıklayınız </a>
          </Typography>
        </Paper>
      </Box>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Pozisyon Adı"
          fullWidth
          value={positionName}
          onChange={(e) => setPositionName(e.target.value)}
          margin="normal"
          required
        />
        {/* Şehir seçimi için select kullanıyoruz */}
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Şehir</InputLabel>
          <Select
            multiple
            value={city}
            onChange={handleCityChange}
            input={<Input />}
            renderValue={(selected) => (
              <div>
                {selected.map((value) => (
                  <Chip key={value} label={value} sx={{ margin: 0.5 }} />
                ))}
              </div>
            )}
            label="Şehir"
          >
            {cities.map((cityName, index) => (
              <MenuItem key={index} value={cityName}>
                {cityName}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>Bir şehir seçin</FormHelperText>
        </FormControl>
        <TextField
          label="İş İlanı Linki"
          fullWidth
          value={jobLink}
          onChange={(e) => setJobLink(e.target.value)}
          margin="normal"
          required
        />
        <TextField
          label="Şirket Adı"
          fullWidth
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          margin="normal"
          required
        />
        {/* Pozisyon Kategorisi için select kullanıyoruz */}
        <FormControl fullWidth margin="normal" required>
          <InputLabel>Pozisyon Kategorisi</InputLabel>
          <Select
            value={positionCategory}
            onChange={(e) => setPositionCategory(e.target.value)}
            label="Pozisyon Kategorisi"
          >
            {positionCategories.map((category, index) => (
              <MenuItem key={index} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>Bir kategori seçin</FormHelperText>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>İlan Türü</InputLabel>
          <Select
            name="job_type"
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
          >
            <MenuItem disabled value="Secilmedi">İlan Türü</MenuItem>
            <MenuItem value="Staj">Staj ilanı</MenuItem>
            <MenuItem value="Is">İş ilanı </MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 5 }} fullWidth>
          <InputLabel>İlan Durumu</InputLabel>
          <Select
            name="job_status"
            value={jobStatus}
            onChange={(e) => setJobStatus(e.target.value)}
          >
            <MenuItem disabled value="Secilmedi">İlan Durum</MenuItem>
            <MenuItem value="0">Pasif</MenuItem>
            <MenuItem value="1">Aktif</MenuItem>
          </Select>
        </FormControl>
          <TextField
          label="Linkedin Resim Url"
          fullWidth
          value={linkedinImageURL}
          onChange={(e) => setlinkedinImageURL(e.target.value)}
          margin="normal"
        />
              <FormControlLabel
        control={
          <Checkbox
            checked={linkedinChecked}
            onChange={handleChange}
            color="primary"
          />
        }
        label="LinkedIn post olarak gönder"
      />
        {error && <Box color="error.main" marginY={1}>{error}</Box>}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          sx={{ marginTop: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : 'İlanı Oluştur'}
        </Button>
      </form>
    </Box>
  );
};

export default CreateOtherPost;
